import React, { CSSProperties, useRef, forwardRef, useImperativeHandle } from 'react';

import GalleryTab from '../gallery-tab/gallery-tab';
import IconArrowLink from '../../atoms/icons/icon-arrow-link';
import Text from '../../atoms/text/text';
import { makeClassNames } from '../../../utils/styles';
import './gallery-tabs-wrapper.scss';
import { IGalleryTabsWrapper, IGalleryTab } from '../../../typings/sports-detail';

const classNames = () =>
  makeClassNames({
    title: 'team-tabs-wrapper__title',
    wrapper: ['team-tabs-wrapper'],
    tabs: 'team-tabs-wrapper__tabs',
    tab: 'team-tabs-wrapper__tab',
    buttonsWrapper: 'team-tabs-wrapper__buttons-wrapper',
    teamNameTitle: 'team-tabs-wrapper__team-name-title',
    button: 'team-tabs-wrapper__button',
    tabWrapper: 'team-tabs-wrapper__tab-wrapper',
    upperCase: 'team-tabs-wrapper__upper-case',
    letterSpacingWide: 'team-tabs-wrapper__letter-spacing-wide',
    footerButton: 'team-tabs-wrapper__footer-button',
    footerButtonWrapper: 'team-tabs-wrapper__footer-button-wrapper',
    footer: 'team-tabs-wrapper__footer',
    footerEmpty: 'team-tabs-wrapper__footer team-tabs-wrapper__footer--empty',
  });

const GalleryTabsWrapper = forwardRef<unknown, IGalleryTabsWrapper>((props: IGalleryTabsWrapper, ref) => {
  const { tabs, title, footerButtonLabel, fakeAdvs, advBoxAttributes } = props;

  const tabsRef = useRef<HTMLDivElement[]>([]);

  const addToTabsRef = (element: HTMLDivElement) => {
    if (element && !tabsRef?.current?.includes(element)) {
      tabsRef.current.push(element);
    }
  };

  useImperativeHandle(ref, () => {
    return {
      tabsRef: tabsRef.current,
    };
  });

  const cn = classNames();
  const styleBackground: CSSProperties = { backgroundColor: tabs[0].tabItemColor };

  const getOtherTeamName = (index: number, teams: IGalleryTab[]) => {
    const otherTeamIndex = index === 0 ? 1 : 0;

    return teams[otherTeamIndex]?.tabName || '';
  };

  const getOtherIntCmp = (index: number, teams: IGalleryTab[]) => {
    const otherTeamIndex = index === 0 ? 1 : 0;

    return teams[otherTeamIndex]?.tabsIntcmp || '';
  };

  return (
    <div className={cn.wrapper}>
      <div className={cn.title}>
        <Text color="blue" fontSize="22" fontWeight="500">
          {title}
        </Text>
      </div>
      {tabs.length > 1 ? (
        <div className={cn.buttonsWrapper} />
      ) : (
        <div className={cn.teamNameTitle} style={styleBackground}>
          <Text color="light" fontSize="32" fontWeight="500" className={cn.upperCase}>
            {tabs?.[0].tabName || ''}
          </Text>
        </div>
      )}
      <div className={cn.tabs}>
        {tabs.map((tab, index) => (
          <div key={`team-${index}`} className={cn.tab} data-analytics-element={tab.dataElement}>
            {tabs.length > 1 && (
              <>
                <input type="radio" name="tabs" id={tab.tabName} defaultChecked={index === 0} />
                <label className={cn.button} htmlFor={tab.tabName} data-intcmp={tab.tabsIntcmp}>
                  <span>{tab.tabName}</span>
                </label>
              </>
            )}
            <div className={cn.tabWrapper}>
              <GalleryTab
                ref={addToTabsRef}
                type={tab.type}
                cards={tab.cards}
                fakeAdvs={fakeAdvs}
                advBoxAttributes={advBoxAttributes}
                trackingDataValues={tab.cardsIntcmp}
              />
            </div>
            {tabs.length > 1 && (
              <div className={cn.footerButtonWrapper}>
                <label
                  className={cn.footerButton}
                  htmlFor={getOtherTeamName(index, tabs)}
                  data-intcmp={getOtherIntCmp(index, tabs)}
                >
                  <Text
                    className={`${cn.upperCase} ${cn.letterSpacingWide}`}
                    fontSize="14"
                    fontWeight="500"
                    color="light"
                  >
                    {footerButtonLabel} {getOtherTeamName(index, tabs)}
                  </Text>
                  <IconArrowLink color="light" size="xxsmall" />
                </label>
              </div>
            )}
          </div>
        ))}
      </div>
      <div className={tabs.length > 1 ? cn.footer : cn.footerEmpty} />
    </div>
  );
});

GalleryTabsWrapper.displayName = 'GalleryTabsWrapper';

export default GalleryTabsWrapper;
